import Toast, { ToastProps } from './Toast';

export type { ToastProps };
export default Toast;
